import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import CustomButton from "components/CustomButton";
import SelectIconInput from "components/files/SelectIconInput";
import SelectInput from "components/files/SelectInput";
import TextInput from "components/files/TextInput";
import { SHORTCUT_NAVIGATE_TO } from "config/const";
import { MINI_SITE_ICON } from "containers/miniSite/const";
import useCheckData from "hooks/CheckData";

const Shortcuts = ({ data, control, errors, setValue }) => {
    const theme = useTheme();
    const { hasPlugin } = useCheckData();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const resetShortcut = (index) => {
        setValue(`shortcuts.${index}.name`, null)
        setValue(`shortcuts.${index}.path`, null)
        setValue(`shortcuts.${index}.icon`, null)
    }

    return (
        <Stack spacing={2}>
            {Array.from({ length: 9 })?.map((short, index) => {
                return (
                    <Stack width='100%' direction={{ xs: "column", md: 'row' }}>
                        <Stack
                            borderRadius={`${isMobile ? "10px 10px 0px 0px" : "10px 0px 0px 10px"}`}
                            bgcolor='primary.main'
                            padding={{ xs: 1, md: 2 }}
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Typography variant="h6" color="bgPage.main">
                                {index + 1}
                            </Typography>
                        </Stack>

                        <Stack
                            width='100%'
                            borderRadius={`${isMobile ? "0px 0px 10px 10px" : "0px 10px 10px 0px"}`}
                            spacing={2}
                            border={1}
                            padding={1}
                        >
                            <Stack width='100%' direction={{ xs: "column", md: 'row' }} spacing={1}>
                                <TextInput
                                    addFlex
                                    errors={errors}
                                    name={`shortcuts.${index}.name`}
                                    title="NAME"
                                    control={control}
                                />
                                <SelectInput
                                    errors={errors}
                                    addFlex
                                    name={`shortcuts.${index}.path`}
                                    title="ACTION"
                                    control={control}
                                    options={SHORTCUT_NAVIGATE_TO
                                        ?.filter(btn => (!btn?.pluginName || hasPlugin(btn?.pluginName)) && (!btn.showRoles || btn.showRoles.includes(data?.userRole)))
                                        ?.map(item => {
                                            return ({ id: item?.path, name: item?.title })
                                        })}
                                />
                            </Stack>

                            <Stack width='100%' direction='row' spacing={1} alignItems='end' justifyContent='space-between'>
                                <SelectIconInput
                                    addFlex
                                    errors={errors}
                                    name={`shortcuts.${index}.icon`}
                                    title="ICON"
                                    control={control}
                                    options={MINI_SITE_ICON}
                                />
                                <CustomButton
                                    height={40}
                                    title="RESET"
                                    color='error'
                                    onClick={() => resetShortcut(index)}
                                />
                            </Stack>
                        </Stack>
                    </Stack>
                )
            })}
        </Stack>

    )
}
export default Shortcuts;